import { ArrangementCase, ArrangementProduct, DecedentProfile, PlannerProfile } from "../types";
import { getProduct } from "../data/demo-arrangement-catalog";

export function formatPlannerName(planner: PlannerProfile) {
  return `${planner.firstName} ${planner.lastName}`.trim();
}

export function formatDecedentName(decedent: DecedentProfile) {
  return [decedent.firstName, decedent.middleName, decedent.lastName].filter(Boolean).join(" ");
}

export function formatServiceDate(date?: string, startTime?: string) {
  if (!date) return "Date to be confirmed";

  const dateLabel = new Intl.DateTimeFormat("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
  }).format(new Date(`${date}T12:00:00`));

  if (!startTime) return dateLabel;

  const timeLabel = new Intl.DateTimeFormat("en-US", {
    hour: "numeric",
    minute: "2-digit",
  }).format(new Date(`${date}T${startTime}:00`));

  return `${dateLabel} · ${timeLabel}`;
}

export function selectedProducts(arrangementCase: ArrangementCase): ArrangementProduct[] {
  return arrangementCase.merchandiseSelections
    .map((selection) => getProduct(selection.productId))
    .filter((product): product is ArrangementProduct => Boolean(product));
}

export function selectedKeepsakes(arrangementCase: ArrangementCase): ArrangementProduct[] {
  return arrangementCase.keepsakes
    .map((selection) => getProduct(selection.productId))
    .filter((product): product is ArrangementProduct => Boolean(product));
}

export function dispositionLabel(disposition: ArrangementCase["disposition"]["type"]) {
  const labels: Record<ArrangementCase["disposition"]["type"], string> = {
    burial: "Burial",
    cremation: "Cremation",
    entombment: "Entombment",
    aquamation: "Aquamation",
    undecided: "Unsure",
  };

  return labels[disposition];
}
